import { useMutation, useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { axios } from 'configurations/axios';
import { ILayerDashboard, ILayerGroupDashboardMainResponse } from '../model/ILayerDashboardMainResponse';
import { getUrlParams } from 'features/seismic-3d/utils/Seismic3DUrlUtils';

export const useGetLayerDashboardInfo = (layerToken: string) => {
    const url = useSessionStore(state => state.tenantConfiguration?.endpoints.layers);
    const apiUrl = window.location.href.indexOf('localhost') > -1 ? 'https://localhost:44322' : url;
    const sessionJwtToken = useSessionStore(state => state.jwtToken);
    const queryStringJwtToken = getUrlParams().jwtToken;

    return useQuery(['layer-dashboard-' + layerToken], async () => {
        const response = await axios.get<IResponseAPI<ILayerDashboard>>(apiUrl + '/LayerDashboard/LayerDashboard/GetLayerForDashboard?layerToken=' + layerToken,
            { headers: {
                Authorization: 'Bearer ' + (sessionJwtToken !== '' ? sessionJwtToken : queryStringJwtToken),
                'Content-Type': 'application/json'
            }
            }
        );
        return response.data.Result;
    },{
        refetchOnMount: false,
        staleTime: Infinity
    });
};

export const useGetLayerGroupDashboardInfo = (dashboardGroupToken: string) => {
    const url = useSessionStore(state => state.tenantConfiguration?.endpoints.layers);
    const apiUrl = window.location.href.indexOf('localhost') > -1 ? 'https://localhost:44322' : url;
    const sessionJwtToken = useSessionStore(state => state.jwtToken);
    const queryStringJwtToken = getUrlParams().jwtToken;

    return useQuery(['layer-dashboard-' + dashboardGroupToken], async () => {
        const response = await axios.get<IResponseAPI<ILayerGroupDashboardMainResponse>>(apiUrl + '/LayerDashboard/LayerDashboard/GetLayerGroupForDashboard?dashboardGroupToken=' + dashboardGroupToken,
            { headers: {
                Authorization: 'Bearer ' + (sessionJwtToken !== '' ? sessionJwtToken : queryStringJwtToken),
                'Content-Type': 'application/json'
            }
            }
        );
        return response.data.Result;
    },{
        refetchOnMount: false,
        staleTime: Infinity
    });
};